// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eEKyTLhOGdVi39Q2BDtF {
  color: var(--store-switcher-block-button-color);
  white-space: nowrap;
  width: 100%;
  max-width: 18.75rem;
  border: 0.125rem solid var(--store-switcher-block-button-color);
  border-radius: 0;
  padding: 0.8125rem 1rem;
  background: var(--store-switcher-block-button-bg)
}

.eEKyTLhOGdVi39Q2BDtF:hover:not([disabled]) {
    background: var(--store-switcher-block-button-bg-hover);
  }

.eEKyTLhOGdVi39Q2BDtF.NwiKz6RvD36kx3niimE_ {
    background: var(--store-switcher-block-button-bg-disabled);
  }

.Xc0LVXth0CPa805tQyph {
  width: 100%;
}

._VnxN9myXd4n1XfHgTAa {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.jBbq8vbGjozy_QK0ALBx,
.E_6ATUZhSVUGHnMMgh1S {
  display: flex;
  align-items: center;
}

.E_6ATUZhSVUGHnMMgh1S {
  margin-left: 0.5rem;
}

.Sy05dCLjFXglBSp6l6SA {
  margin-right: 0.5625rem;
}

.uO_xtb6tZMwJhC_Ye0ni {
  color: var(--store-switcher-block-button-color);
  word-break: normal;
}

.bQ2WLnP5N61I6PfgMyYo {
  text-decoration: underline;
}

.YYf2sVILLSdHRi9jgCfQ {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 1.0625rem;
}

@media only screen and
  (max-width: 639px) {
  .eEKyTLhOGdVi39Q2BDtF {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StoreSwitcherButton/StoreSwitcherButton.module.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,WAAW;EACX,mBAAgB;EAChB,+DAA0D;EAC1D,gBAAgB;EAChB,uBAAkB;EAClB;AASF;;AAPE;IACE,uDAAuD;EACzD;;AAEA;IACE,0DAA0D;EAC5D;;AAGF;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAgB;AAClB;;AAEA;EACE,uBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAiB;AACnB;;AAEA;;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".storeSwitcherButton {\n  color: var(--store-switcher-block-button-color);\n  white-space: nowrap;\n  width: 100%;\n  max-width: 300px;\n  border: 2px solid var(--store-switcher-block-button-color);\n  border-radius: 0;\n  padding: 13px 16px;\n  background: var(--store-switcher-block-button-bg);\n\n  &:hover:not([disabled]) {\n    background: var(--store-switcher-block-button-bg-hover);\n  }\n\n  &.disabled {\n    background: var(--store-switcher-block-button-bg-disabled);\n  }\n}\n\n.content {\n  width: 100%;\n}\n\n.storeSwitcherContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.storeSwitcherContentLeft,\n.storeSwitcherContentRight {\n  display: flex;\n  align-items: center;\n}\n\n.storeSwitcherContentRight {\n  margin-left: 8px;\n}\n\n.globeIcon {\n  margin-right: 9px;\n}\n\n.text {\n  color: var(--store-switcher-block-button-color);\n  word-break: normal;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.linkButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 17px;\n}\n\n@media (--mobile) {\n  .storeSwitcherButton {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"storeSwitcherButton": `eEKyTLhOGdVi39Q2BDtF`,
	"disabled": `NwiKz6RvD36kx3niimE_`,
	"content": `Xc0LVXth0CPa805tQyph`,
	"storeSwitcherContent": `_VnxN9myXd4n1XfHgTAa`,
	"storeSwitcherContentLeft": `jBbq8vbGjozy_QK0ALBx`,
	"storeSwitcherContentRight": `E_6ATUZhSVUGHnMMgh1S`,
	"globeIcon": `Sy05dCLjFXglBSp6l6SA`,
	"text": `uO_xtb6tZMwJhC_Ye0ni`,
	"underline": `bQ2WLnP5N61I6PfgMyYo`,
	"linkButton": `YYf2sVILLSdHRi9jgCfQ`
};
export default ___CSS_LOADER_EXPORT___;
